import { render, staticRenderFns } from "./PanelFatalElem.vue?vue&type=template&id=7499a074&"
import script from "./PanelFatalElem.vue?vue&type=script&lang=js&"
export * from "./PanelFatalElem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports